export const options = [
    { label: '24 horas', value: 24 },
    { label: '48 horas', value: 48 },
]